import * as React from 'react';
import AuthLoginForm from "./login/auth_login_form";
import {AuthWrapper} from "./share/auth_share_components";

interface IProps {
    handleCallLogin: (values: any) => void;
}

const AuthLoginComponent: React.FC<IProps> = (props) => {
    const { handleCallLogin } = props;

    return (
        <React.Fragment>
            <AuthWrapper>
                <AuthLoginForm onSubmit={handleCallLogin} />
            </AuthWrapper>
        </React.Fragment>
    )

};

export default AuthLoginComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_login.tsx